<template>
  <div>
    <div
      class="drop-image cursor-pointer"
      style="position: relative; min-height: 60px; width: 100%;"
      :class="{ dragover: dragover }"
      dropzone
      :error="true"
      @drop.prevent.stop="drop"
      @dragover.prevent.stop="dragEnter"
      @dragenter.prevent.stop="dragEnter"
      @dragleave.prevent.stop="dragLeave"
      @mouseenter.prevent.stop="dragEnter"
      @mouseleave.prevent.stop="dragLeave"
      @click="$refs.file.click()"
    >
      <video
        v-if="model[videoUrlProperty]"
        style="width: 100%"
        autoplay
        loop
        muted
      >
        <source
          :src="model[videoUrlProperty]"
          type="video/mp4"
        >
      </video>
      <div
        v-if="dragover"
        class="absolute-full text-subtitle2 flex flex-center"
        style="pointer-events: none;"
      >
        Drop Video Here
      </div>
      <div
        v-if="!dragover && !model[videoUrlProperty]"
        class="absolute-full text-subtitle2 flex flex-center bg-white text-black"
        style="pointer-events: none;"
      >
        Drop Video Here
      </div>
      <q-btn
        v-if="dragover && model[videoUrlProperty]"
        style="position: absolute; right: 5px; top: 5px;"
        class="pull-right"
        icon="close"
        color="white"
        text-color="black"
        round
        @click.stop="update(null)"
      />
      <q-inner-loading :showing="loading" />
    </div>
    <input
      v-show="false"
      ref="file"
      type="file"
      @change="fileSelected"
    >
  </div>
</template>

<script>

export default {
  name: 'VideoUploader',
  props: {
    modelValue: {
      type: String,
      required: false,
      default: null
    },
    videoUrlProperty: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  emits: ['update:model-value', 'loading'],
  data () {
    return {
      dragover: false,
      loading: false
    }
  },
  methods: {
    update (value) {
      this.$emit('update:model-value', value)
    },
    fileSelected (event) {
      const file = event.target.files[0]

      if (!file) return

      this.upload(file)
    },
    drop (event) {
      event.preventDefault()
      const file = event.dataTransfer.files[0]

      if (!file) return

      this.upload(file)
    },
    async upload (file) {
      this.loading = true
      this.$emit('loading', true)

      const { key } = await this.$directUpload.uploadFile(file)

      this.update(key)

      this.$emit('loading', false)
      this.loading = false
      this.dragover = false
    },
    dragEnter () {
      this.dragover = true
    },
    dragLeave () {
      this.dragover = false
    }
  }
}

</script>

<style lang="scss" scoped>
.drop-image {
  border: solid 2px black;
}
.dragover {
  border: dotted 4px red !important;
}
</style>
